/**
 * A session timeout always lands the customer back on the preauth gate with
 * a "session timed out" dialog, regardless of how they entered (account
 * cookie or notification-link grant). Like the dashboard notices, the signal
 * travels in the query string — `/appointment?expired=1` — because the
 * navigation drops client state.
 */
export const SESSION_EXPIRED_PARAM = "expired";

/** Public dashboard path announcing a timed-out session (the wgl rewrite maps it to /f/appointment). */
export function sessionExpiredHref(): string {
  return `/appointment?${SESSION_EXPIRED_PARAM}=1`;
}

/** Whether the request carries the session-timeout marker. */
export function readSessionExpired(
  searchParams: Record<string, string | undefined>,
): boolean {
  return searchParams[SESSION_EXPIRED_PARAM] === "1";
}
